<r1-compass-lib-instructions headerText="Rules">
    Add rules by clicking '+Add'. To edit a rule, choose 'Edit' from the additional options menu on the rule. The
    content for the first applicable rule will be used, starting with the rule in the first position. Rules can be
    reordered by clicking and dragging the rules.
</r1-compass-lib-instructions>
<div class="rules-list-container">
    <div class="rules-list" cdkDropList (cdkDropListDropped)="drop($event)">
        @if (asset(); as asset) {
            @for (rule of rulesWithValidation(); track $index) {
                <div class="rule-main-container" cdkDrag cdkDragBoundary=".rules-list" cdkDragLockAxis="y">
                    <div class="rule-index-tab">{{ $index + 1 }}</div>
                    <div class="rule-content-container">
                        <div class="rule-content">
                            <p class="rule-name">{{ rule.name }}</p>
                            <p class="rule-summary">{{ rule | r1ContentLibraryRuleSummary: fields() ?? [] }}</p>
                        </div>
                        <div class="rule-end-container">
                            <div
                                class="sidenav-validation-indicator"
                                [style.visibility]="!rule.valid ? 'visible' : 'hidden'">
                                <fa-icon [icon]="['fas', 'triangle-exclamation']" style="color: var(--r1-orange)" />
                            </div>
                            <div class="rule-options-container">
                                <div class="options-menu-container" [matMenuTriggerFor]="menu">
                                    <fa-icon [icon]="faEllipsisVertical" />
                                </div>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="onEdit(rule)" type="button">Edit</button>
                                    <button mat-menu-item (click)="onCopy(asset, rule)" type="button">Copy</button>
                                    <button mat-menu-item (click)="onDelete(asset, rule)" type="button">Delete</button>
                                </mat-menu>
                            </div>
                        </div>
                    </div>
                </div>
            }
        }
    </div>
    <div class="rules-list-footer">
        <button (click)="onAddRule()" class="button button-black" type="button">+Add</button>
    </div>
</div>
<div class="component-footer">
    <button class="button button-brilliant-blue" (click)="onSave()" [disabled]="disableSave()" type="submit">Save</button>
</div>
